import React from 'react';
import { Typography, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SubjectIcon from '@material-ui/icons/Subject';

type SimpleFooterItemProps = {
	item: any;
	handleDeleteFooterItem: (_id: any) => void;
};

const SimpleFooterItem = ({ item, handleDeleteFooterItem }: SimpleFooterItemProps) => {
	const { id, content } = item;

	return (
		<div
			style={{
				border: '1px solid #909CA5',
				borderRadius: 4,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '14px 0 14px 10px',
					flex: 1,
					overflow: 'hidden',
				}}
			>
				<SubjectIcon fontSize="small" style={{ flexShrink: 0 }} />
				<Typography
					variant="body1"
					style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
					title={content}
				>
					{content || 'Simple footer'}
				</Typography>
			</div>
			<Button
				style={{ minWidth: 0, padding: '14px 10px', borderRadius: 0, borderLeft: '1px solid #909CA5' }}
				onClick={(e) => {
					e.stopPropagation();
					handleDeleteFooterItem(id);
				}}
			>
				<CloseIcon fontSize="small" />
			</Button>
		</div>
	);
};

export default SimpleFooterItem;
